// 중앙위원회 상단 배너
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import "./Tab.css";

const COUNCIL_NAMES_STORAGE_KEY = "councilNames";

const COLLEGE_TABS = [
  {
    collegeId: 1,
    path: "Scitech",
    name: "과학기술대학",
  },
  {
    collegeId: 2,
    path: "Global",
    name: "글로벌융합대학",
  },
  {
    collegeId: 3,
    path: "Future",
    name: "미래인재대학",
  },
  {
    collegeId: 4,
    path: "Pharm",
    name: "약학대학",
  },
  {
    collegeId: 5,
    path: "ArtDesign",
    name: "Art & Design 대학",
  },
  {
    collegeId: 6,
    path: "Club",
    name: "동아리연합회",
  },
];

const getSavedCouncilNames = () => {
  try {
    const saved = localStorage.getItem(COUNCIL_NAMES_STORAGE_KEY);

    if (!saved) return [];

    const parsed = JSON.parse(saved);

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const getDisplayName = (college, savedNames) => {
  const saved = savedNames.find(
    (item) =>
      Number(item.collegeId || item.id) === Number(college.collegeId)
  );

  if (!saved) return college.name;

  return (
    saved.shortName ||
    saved.currentName?.replace(" 학생회", "") ||
    saved.name?.replace(" 학생회", "") ||
    college.name
  );
};

export default function Tab() {
  const location = useLocation();
  const [savedNames, setSavedNames] = useState(getSavedCouncilNames);

  useEffect(() => {
    const syncCouncilNames = () => {
      setSavedNames(getSavedCouncilNames());
    };

    window.addEventListener("storage", syncCouncilNames);
    window.addEventListener("councilNamesUpdated", syncCouncilNames);

    return () => {
      window.removeEventListener("storage", syncCouncilNames);
      window.removeEventListener("councilNamesUpdated", syncCouncilNames);
    };
  }, []);

  const tabs = useMemo(() => {
    return COLLEGE_TABS.map((college) => ({
      path: `/cc/${college.path}`,
      name: getDisplayName(college, savedNames),
    }));
  }, [savedNames]);

  return (
    <div className="Organization-chart">
      {tabs.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          state={{ activeTab: "intro" }}
          className={({ isActive }) => {
            if (tab.path === "/cc/Scitech") {
              return isActive || location.pathname === "/cc"
                ? "chart active"
                : "chart";
            }

            return isActive ? "chart active" : "chart";
          }}
        >
          {tab.name}
        </NavLink>
      ))}
    </div>
  );
}